import { render, staticRenderFns } from "./CommHome.vue?vue&type=template&id=2dbed863&scoped=true&"
import script from "./CommHome.vue?vue&type=script&lang=js&"
export * from "./CommHome.vue?vue&type=script&lang=js&"
import style0 from "./CommHome.vue?vue&type=style&index=0&id=2dbed863&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbed863",
  null
  
)

export default component.exports